/**
 * Utility functions for managing GlobalOptions data in localStorage
 */

/**
 * Get GlobalOptions data from localStorage
 * @returns {Array} Array of GlobalOptions objects
 */
export const getGlobalOptions = () => {
  try {
    const data = localStorage.getItem('GlobalOptions');
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error('Error parsing GlobalOptions from localStorage:', error);
    return [];
  }
};

/**
 * Get the first GlobalOptions object (most common use case)
 * @returns {Object|null} First GlobalOptions object or null
 */
export const getFirstGlobalOption = () => {
  const options = getGlobalOptions();
  return options.length > 0 ? options[0] : null;
};

/**
 * Get a specific field from the first GlobalOptions object
 * @param {string} fieldName - Name of the field to retrieve
 * @param {any} defaultValue - Default value if field doesn't exist
 * @returns {any} Field value or default value
 */
export const getGlobalOptionField = (fieldName, defaultValue = '') => {
  const firstOption = getFirstGlobalOption();
  return firstOption ? (firstOption[fieldName] || defaultValue) : defaultValue;
};

/**
 * Save GlobalOptions data to localStorage
 * @param {Array} globalOptions - Array of GlobalOptions objects
 */
export const saveGlobalOptions = (globalOptions) => {
  try {
    localStorage.setItem('GlobalOptions', JSON.stringify(globalOptions));
    console.log('GlobalOptions saved to localStorage:', globalOptions);
  } catch (error) {
    console.error('Error saving GlobalOptions to localStorage:', error);
  }
};

/**
 * Update GlobalOptions data in localStorage
 * @param {Object} updatedData - Updated GlobalOptions object
 */
export const updateGlobalOptions = (updatedData) => {
  try {
    const existingOptions = getGlobalOptions();
    if (existingOptions.length > 0) {
      // Update the first (and typically only) GlobalOptions object
      const updatedOptions = [{ ...existingOptions[0], ...updatedData }];
      saveGlobalOptions(updatedOptions);
    } else {
      // If no existing data, create new array with the updated data
      saveGlobalOptions([updatedData]);
    }
  } catch (error) {
    console.error('Error updating GlobalOptions in localStorage:', error);
  }
};
